// @flow
// @jsx h

// External librairies
import { h } from "preact";
import {ThemeConfig} from "elc-theme"

// Style
import styles from "./TabIcon.scss";

/**
 * Tab icon container that accept as a children a JSX SVG
 */
const TabIcon = ({ theme, active, children }, context) => (
  <ThemeConfig.Consumer>
  { themeConfig => {
     return(
  <div
    class={`${styles.iconContainer} ${
      active
        ? theme && theme.iconActive
          ? theme.iconActive
          : styles.iconActive
        : theme && theme.iconInactive
          ? theme.iconInactive
          : styles.iconInactive
    }`}
    style={`background-color:${
      themeConfig && themeConfig.color1 && active
        ? themeConfig.color1
        : ""
    };`}
  >
    {children}
  </div>
  		 )}
      }
  </ThemeConfig.Consumer>
);

export default TabIcon;
